


// activate SLider and Yotpo for product pages
jQuery(document).on('pagecontainershow', function (event, ui) {
   if (ui.toPage[0].className.includes('template-product')) {
     var page = jQuery(ui.toPage[0]);
     startSlider(event, page);
    Shopify.AjaxifyCart.init();  
   }
  if (ui.toPage[0].id == 'index') {
    var page = jQuery(ui.toPage[0]);
   Shopify.AjaxifyCart.init();
  }
});





// activate FAQ Accordion on product pages
jQuery(document).on('pagecontainerbeforeshow', function (event, ui) {
   if (ui.toPage[0].className.includes('template-product')) {
 	helpaccordion2();  
   }
});


// remove previous product pages
jQuery(document).on('pagecontainerhide', function (event, ui) {
   if (ui.prevPage[0].className.includes('template-product')) {
      jQuery(ui.prevPage[0]).remove(); 
   }
});



$(document).on("pagecontainerbeforeshow", function(event, ui) {
    //if index or product page before show
    if (ui.toPage[0].id == 'index' || ui.toPage[0].className.includes('template-product')) {
        jQuery(function() {
            var page = jQuery(ui.toPage[0]);
            page.find('.swatch :radio').change(function() {
                var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                var optionValue = jQuery(this).val();
                jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
            });
        });
    }
});


function startSlider(event, page) {
  
  
  
  
  
  
  
var container = page.find('.gallery-thumbs');
var container2 = page.find('.gallery-top');   

  
  
   var galleryThumbs = new Swiper((container), {
      spaceBetween: 10,
      slidesPerView: 'auto',
      loop: false,
     direction: 'vertical',
      freeMode: true,
      loopedSlides: 5, //looped slides should be the same
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
       // when window width is <= 320px
       1022: {
       direction: 'horizontal',
         spaceBetween: 1,
        }
     }
    });
  
  
var container2 = page.find('.gallery-top');  
   var galleryTop = new Swiper((container2), {
      spaceBetween: 0,
      loop:false,
      effect: 'fade',
      zoom: true,
          autoHeight: true	,
      fadeEffect: {
        crossFade: true
      },
      thumbs: {
        swiper: galleryThumbs,
      },
    });  
  
  
  

  
  
  
}




function helpaccordion2() {
var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("show");
  }
} 
}





 